import Link from 'next/link'
import classes from './BreadCrumbs.module.scss'

const Breadcrumbs = ({ items }) => {
  return (
    <div className={classes.breadcrumbs}>
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol>
            <li>
              <Link href="/">Home</Link>
            </li>
            {items.map((item, index) => (
              <li key={index}>
                {index === items.length - 1 ? (
                  <span>{item.label}</span>
                ) : (
                  <Link href={item.href}>{item.label}</Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  )
}

export default Breadcrumbs